import { hasActiveDemoAccess } from "./demoAccess";

const EXTENDED_KEY = "baysport_extended_nav";
export function getExtendedNavStorageKey(tenantId) {
  return tenantId ? `${EXTENDED_KEY}_${tenantId}` : EXTENDED_KEY;
}

export function readExtendedNavManual(tenantId) {
  if (!tenantId) return false;
  return localStorage.getItem(getExtendedNavStorageKey(tenantId)) === "1";
}

export function writeExtendedNavManual(tenantId, enabled) {
  if (!tenantId) return;
  if (enabled) {
    localStorage.setItem(getExtendedNavStorageKey(tenantId), "1");
  } else {
    localStorage.removeItem(getExtendedNavStorageKey(tenantId));
  }
}

export function isExtendedNavEnabled(club, tenant, billing) {
  const tenantId = tenant?.id;
  if (hasActiveDemoAccess(tenant, billing)) return true;
  const teamCount = Number(club?.team_members_count ?? 0);
  const isSolo = club?.is_solo_club ?? teamCount <= 1;
  const isClubPlan =
    tenant?.plan_tier === "club" || club?.plan_tier === "club";
  if (isClubPlan || !isSolo) return true;
  return readExtendedNavManual(tenantId);
}
